<!-- 関連伝票ダイアログ -->
<template>
  <div>
    <b-modal  class="cx_access_dialog" v-model="showDialog" title="関連伝票" @ok="onOk" :no-close-on-backdrop="true" centered v-if="showDialog" :ok-only="true" ok-title="閉じる">
        <!-- 利用状況 -->
        <!-- <div class="cx_usage_section">      

          <div class="cx_usage_container">    -->
            <div class="cx_access_panel" v-if="isVisible(DirectAccessTargetFlags.SalesOrder | DirectAccessTargetFlags.SalesOrderPayment | DirectAccessTargetFlags.SalesDelivery | DirectAccessTargetFlags.SalesInvoice | DirectAccessTargetFlags.SalesCharge | DirectAccessTargetFlags.SalesPayment)">
              <span  class="cx_access_title">【販売管理】</span>
              <div>

                <div class="cx_access_container" v-if="isVisible(DirectAccessTargetFlags.SalesOrder)">                  
                    <div class="cx_access_header"><span>受注</span>
                    </div>
                    <div>
                      <span v-if="queryResult.salesOrders.length==0">未実施</span>                      
                      <div class="cx_access_row" v-for="(item,index) in queryResult.salesOrders" :key="index">
                        <div class="cx_access_item">
                          <span :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/sales/SalesOrder?orderNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | salesOrderStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>

                <div  class="cx_access_container"  v-if="isVisible(DirectAccessTargetFlags.SalesOrderPayment) && hasLicenseExport">
                    <div class="cx_access_header"><span>前受</span>
                    </div>
                    <div>
                      <span v-if="queryResult.salesOrderPayments.length==0">未実施</span>
                      <div class="cx_access_row" v-for="(item,index) in queryResult.salesOrderPayments" :key="index">
                        <div class="cx_access_item">
                          <span :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/cash/Deposit?paymentNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | receivePaymentStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div> 

                <div  class="cx_access_container"  v-if="isVisible(DirectAccessTargetFlags.SalesDelivery)">
                  <!-- 発注・入荷で表示される場合は直送 -->
                    <div class="cx_access_header"><span>{{source==DirectAccessTargetFlags.PurchaseOrder || source == DirectAccessTargetFlags.PurchaseDelivery ? '直送': '出荷'}}</span>
                    </div>
                    <div>
                      <span v-if="queryResult.salesDeliveries.length==0">未実施</span>
                      <div class="cx_access_row" v-for="(item,index) in queryResult.salesDeliveries" :key="index">
                        <div class="cx_access_item">
                          <span  :class="{cx_link_item : item.isSource == false}" v-if="item.voucherNo=='allocation'" @click="item.isSource? null:onAllocationClick()">出荷指示待ち</span>                      
                          <span  :class="{cx_link_item : item.isSource == false}" v-if="item.voucherNo!='allocation'" @click="item.isSource? null:onLinkClick('/sales/SalesDelivery?deliveryNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state" v-if="item.voucherNo!='allocation'">({{item.state | salesDeliveryStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>          

                <div  class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.SalesInvoice)">
                    <div class="cx_access_header"><span>請求</span>
                    </div>
                    <div>
                      <span v-if="queryResult.salesInvoices.length==0">未実施</span>                        
                      <div class="cx_access_row" v-for="(item,index) in queryResult.salesInvoices" :key="index">
                        <div class="cx_access_item">
                          <span  :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onInvoiceClick(item.voucherNo, item.state)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | salesInvoiceStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>          
                <div  class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.SalesCharge)">
                    <div class="cx_access_header"><span>諸掛</span>
                    </div>
                    <div>
                      <span v-if="queryResult.salesCharges.length==0">未実施</span>                        
                      <div class="cx_access_row" v-for="(item,index) in queryResult.salesCharges" :key="index">
                        <div class="cx_access_item">
                        <span  :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/sales/SalesCharge?chargeNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | chargeStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>          
                <div  class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.SalesPayment)">
                    <div class="cx_access_header"><span>入金</span>
                    </div>
                    <div>
                      <span v-if="queryResult.salesPayments.length==0">未実施</span>                           
                      <div class="cx_access_row" v-for="(item,index) in queryResult.salesPayments" :key="index">
                        <div class="cx_access_item">
                          <span  :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/cash/Deposit?paymentNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | receivePaymentStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>          

              </div>
            </div>
            <div class="cx_access_panel" v-if="isVisible(DirectAccessTargetFlags.PurchaseOrder | DirectAccessTargetFlags.PurchaseOrderPayment | DirectAccessTargetFlags.PurchaseDelivery | DirectAccessTargetFlags.PurchaseInvoice | DirectAccessTargetFlags.PurchaseCharge | DirectAccessTargetFlags.PurchasePayment)">
              <span  class="cx_access_title">【仕入管理】</span>            
              <div>

                <div class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.PurchaseOrder)">                  
                    <div class="cx_access_header"><span>発注</span>
                    </div>
                    <div>
                      <span v-if="queryResult.purchaseOrders.length==0">未実施</span>                      
                      <div class="cx_access_row" v-for="(item,index) in queryResult.purchaseOrders" :key="index">
                        <div class="cx_access_item">
                          <span :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/purchase/PurchaseOrder?orderNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | purchaseOrderStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>

                <div class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.PurchaseOrderPayment) && hasLicenseImport">                  
                    <div class="cx_access_header"><span>前払</span>
                    </div>
                    <div>
                      <span v-if="queryResult.purchaseOrderPayments.length==0">未実施</span>                      
                      <div class="cx_access_row" v-for="(item,index) in queryResult.purchaseOrderPayments" :key="index">
                        <div class="cx_access_item">
                          <span :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/cash/WithDrawal?paymentNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | sendPaymentStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>

                <div  class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.PurchaseDelivery)">
                    <div class="cx_access_header"><span>入荷</span>
                    </div>
                    <div>
                      <span v-if="queryResult.purchaseDeliveries.length==0">未実施</span>
                      <div class="cx_access_row" v-for="(item,index) in queryResult.purchaseDeliveries" :key="index">
                        <div class="cx_access_item">
                          <span  :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/purchase/PurchaseDelivery?deliveryNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | purchaseDeliveryStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>       

                <div  class="cx_access_container"    v-if="isVisible(DirectAccessTargetFlags.PurchaseInvoice)">
                    <div class="cx_access_header"><span>仕入</span>
                    </div>
                    <div>
                      <span v-if="queryResult.purchaseInvoices.length==0">未実施</span>                        
                      <div class="cx_access_row" v-for="(item,index) in queryResult.purchaseInvoices" :key="index">
                        <div class="cx_access_item">
                          <span :class="{cx_link_item : item.isSource == false}"  @click="item.isSource? null:onLinkClick('/purchase/PurchaseInvoice?invoiceNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | purchaseInvoiceStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>      
                <div  class="cx_access_container"   v-if="isVisible(DirectAccessTargetFlags.PurchaseCharge)">
                    <div class="cx_access_header"><span>諸掛</span>
                    </div>
                    <div>
                      <span v-if="queryResult.purchaseCharges.length==0">未実施</span>                        
                      <div class="cx_access_row" v-for="(item,index) in queryResult.purchaseCharges" :key="index">
                        <div class="cx_access_item">
                          <span  :class="{cx_link_item : item.isSource == false}" @click="item.isSource? null:onLinkClick('/purchase/PurchaseCharge?chargeNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | chargeStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>  
                <div  class="cx_access_container"    v-if="isVisible(DirectAccessTargetFlags.PurchasePayment)">
                    <div class="cx_access_header"><span>支払</span>
                    </div>
                    <div>
                      <span v-if="queryResult.purchasePayments.length==0">未実施</span>                           
                      <div class="cx_access_row" v-for="(item,index) in queryResult.purchasePayments" :key="index">
                        <div class="cx_access_item">
                          <span :class="{cx_link_item : item.isSource == false}"  @click="item.isSource? null:onLinkClick('/cash/WithDrawal?paymentNo=' + item.voucherNo)">{{item.voucherNo}}</span><span class="cx_access_state">({{item.state | sendPaymentStatus}})</span><i  v-if="item.completed" class="material-icons small valign cx_ok">check_circle</i><i  v-if="! item.completed" class="material-icons small valign cx_alert">warning</i>
                        </div>
                        <span class="cx_access_item2">{{$api.formatter.formatDate(item.voucherDate)}}</span>
                        <span class="cx_access_item3">{{$api.formatter.formatAmountFCMark(item.voucherAmount, item.voucherCurrency)}}</span>
                      </div>
                    </div>
                </div>        


               </div> 
            </div>                      
          <!-- </div>           
        </div>        -->
    </b-modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class DirectAccessDialog extends Vue {
  @Prop({default:null}) public source:Common.DirectAccessTargetFlags; 
  @Prop({default:null}) public sourceNo:string;
  @Prop({default:false}) public isItem:boolean;

  showDialog: boolean = false;
  queryResult : Common.DirectAccessQueryResult;
  DirectAccessTargetFlags = Common.DirectAccessTargetFlags;

  created(){
    this.$api.execute(new Common.DirectAccessQuery(this.source,this.sourceNo,this.isItem))
    .then(obj => {
        this.queryResult = obj;
        this.showDialog = true;
      })
  }
  
  isVisible(target : Common.DirectAccessTargetFlags){
    return (this.queryResult.target & target) > 0;
  }

  get hasLicenseImport() :boolean{
    return this.$api.hasLicense(Common.licenseFlags.import);
  }
  get hasLicenseExport() :boolean{
    return this.$api.hasLicense(Common.licenseFlags.export);
  }


  onOk(){
    this.showDialog = false;
  }

  onAllocationClick(){
      this.onLinkClick('/sales/SalesDeliveryItem?orderItemNo=' + this.sourceNo + '&state=' + Common.StockBalanceJournalStatus.SalesDeliveryInstructionWaiting);
  }
  onInvoiceClick(invoiceNo:string,state :number){
    if ((state & Common.InvoiceStatus.CarryOver) == 0) this.onLinkClick('/sales/AloneInvoice?invoiceNo=' + invoiceNo);
    else this.onLinkClick('/sales/CarryOverInvoice?invoiceNo=' + invoiceNo);
  }

  onLinkClick(path : string){
    this.showDialog = false;
    this.$router.push(path);
    // let routeData = this.$router.resolve(path);
    // window.open(routeData.href, '_blank');        
  }

}
</script>
<style lang="scss">
.cx_access_dialog{
  .modal-dialog{
    max-width: 800px;
    .modal-body {
      max-height: 60vh;
      overflow-y: auto;
    }
  }
  .cx_access_panel{
    display: flex;  
  }
  .cx_access_title{
    width:140px;
    margin-top:5px;
  }
  .cx_access_container{
    display:flex;
    padding: 5px 30px;
    font-size: 15px;
    .cx_access_header{
      width:60px;      
    }
    .cx_access_row {
      display: table;
      width: 400px;
    }
    .cx_access_item{
      display: table-cell;
      align-items: left;
      text-align: left;
      min-width: 240px;
    }
    .cx_access_item2{
      display: table-cell;
      align-items: right;
      text-align: right;
      min-width: 100px;
    }
    .cx_access_item3{
      display: table-cell;
      align-items: right;
      text-align: right;
      min-width: 140px;
    }
    .cx_access_state{
      margin-left:5px;
      min-width: 120px;
      text-align: left;
    }

    .material-icons{
      &.cx_ok{
        color: #4ec23f;
      }
      &.cx_alert{
        color: #c516166c;            
      }
      font-size: 14px;
      margin-left:5px;
    }    
  }
}
</style>